import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import ExerciseLayout from './ExerciseLayout';
import MarkdownContent from './MarkdownContent';
import { jsx as ___EmotionJSX } from "@emotion/react";
const NormalExercise = _ref => {
  let {
    completionPaneVisible,
    exercise,
    feedbackMessages,
    hideCompletionPane,
    interactionBlocked,
    onExerciseFinished,
    onRate,
    resetWorkbook,
    showExercise,
    showHint,
    showSolution,
    solutionShown,
    submitExercise,
    successMessage,
    workbook,
    workbookReady,
    xpLost
  } = _ref;
  return ___EmotionJSX(ExerciseLayout, _extends({
    completionPaneVisible,
    exercise,
    feedbackMessages,
    hideCompletionPane,
    interactionBlocked,
    onExerciseFinished,
    onRate,
    resetWorkbook,
    showExercise,
    showHint,
    showSolution,
    solutionShown,
    submitExercise,
    successMessage,
    workbook,
    workbookReady,
    xpLost
  }, {
    instructions: ex => ___EmotionJSX(MarkdownContent, {
      markdown: ex.instructions
    })
  }));
};
export default NormalExercise;